import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// `call`, just like a function.
export var RawTask = /*#__PURE__*/function () {
  function RawTask(onError, release) {
    _classCallCheck(this, RawTask);

    this.onError = onError;
    this.release = release;
    this.task = null;
  }

  _createClass(RawTask, [{
    key: "call",
    value: function call() {
      try {
        this.task && this.task();
      } catch (error) {
        this.onError(error);
      } finally {
        this.task = null;
        this.release(this);
      }
    }
  }]);

  return RawTask;
}();